import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetAllEntitiesSummaryUseCaseInterface } from 'domain/usecases';

export class RemoteGetAllEntitiesSummary
  implements GetAllEntitiesSummaryUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<GetAllEntitiesSummaryUseCaseInterface.Result>,
  ) {}

  async execute(): Promise<GetAllEntitiesSummaryUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: this.url,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body?.message);
    }
  }
}
